export const colorClasses: Record<string, Record<string, string>> = {
	primary: {
		red: "text-lightRed bg-secondaryRed hover:bg-darkRed",
		blue: "text-lightBlue bg-secondaryBlue hover:bg-darkBlue",
		green: "text-lightGreen bg-secondaryGreen hover:bg-darkGreen",

		sunset: "text-lightSunset bg-secondarySunset hover:bg-darkSunset",
		tangerine: "text-lightTangerine bg-secondaryTangerine hover:bg-darkTangerine",
		ivory: "text-lightIvory bg-secondaryIvory hover:bg-darkIvory",
		blush: "text-lightBlush bg-secondaryBlush hover:bg-darkBlush",
		porcelain: "text-lightPorcelain bg-secondaryPorcelain hover:bg-darkPorcelain",
		facebook: "text-white bg-[#1877F2] hover:bg-[#0d65d9]",
		instagram: "text-white bg-[#E1306C] hover:bg-[#C13584]",
		default: "text-white bg-primaryTangerine hover:bg-darkTangerine",
	},
	secondary: {
		red: "text-darkRed bg-lightRed hover:bg-primaryRed",
		blue: "text-white bg-primaryBlue hover:bg-secondaryBlue",
		green: "text-white bg-primaryGreen hover:bg-secondaryGreen",

		sunset: "text-darkSunset bg-lightSunset hover:bg-primarySunset",
		tangerine: "text-darkTangerine bg-lightTangerine hover:bg-primaryTangerine",
		ivory: "text-darkIvory bg-lightIvory hover:bg-secondaryIvory",
		blush: "text-darkBlush bg-lightBlush hover:bg-primaryBlush",
		porcelain: "text-darkPorcelain bg-lightPorcelain hover:bg-primaryPorcelain",
		facebook: "text-[#0d65d9] bg-[#DCE8FF] hover:bg-[#bdd5ff]",
		instagram: "text-[#C13584] bg-[#FDD6E3] hover:bg-[#FAB8CF]",
		default: "text-darkTangerine bg-lightTangerine hover:bg-primaryTangerine",
	},
};
